var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMediaDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43613 10.9902H8.38949C9.35497 10.9902 9.83538 10.5005 9.83538 9.53035V5.29527H6.45852C5.8615 5.29527 5.57699 5.01076 5.57699 4.41374V0.990234H3.43613C2.47531 0.990234 1.99023 1.48464 1.99023 2.45479V9.53035C1.99023 10.5052 2.47064 10.9902 3.43613 10.9902ZM6.47251 4.65628H9.77941C9.75143 4.46505 9.61617 4.27848 9.39229 4.04994L6.82232 1.43333C6.60311 1.20945 6.41188 1.07419 6.21598 1.04154V4.40441C6.21598 4.57232 6.29994 4.65628 6.47251 4.65628ZM5.91281 9.80553C5.82419 9.80553 5.7449 9.77288 5.65161 9.68893L4.35964 8.4949C4.28501 8.4296 4.24303 8.35031 4.24303 8.24303C4.24303 8.06113 4.38296 7.92587 4.57419 7.92587C4.65814 7.92587 4.75609 7.96318 4.82139 8.02848L5.21785 8.4296L5.58632 8.8074L5.55833 8.10311V6.53128C5.55833 6.34471 5.72158 6.18613 5.91281 6.18613C6.10404 6.18613 6.26729 6.34471 6.26729 6.53128V8.10311L6.2393 8.8074L6.60777 8.4296L7.00423 8.02848C7.06953 7.96318 7.16281 7.92587 7.25143 7.92587C7.438 7.92587 7.58258 8.06113 7.58258 8.24303C7.58258 8.35031 7.54061 8.42494 7.46598 8.4949L6.174 9.68893C6.08072 9.77288 6.00143 9.80553 5.91281 9.80553Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMediaDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-media-download.1145cb7907ce21786fc56c9fb60fe36f.svg";